import { makeStyles } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import React from 'react';
import NPaper from '../../NPaper';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    scrollSnapAlign: 'start',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      width: 90,
      height: 80,
      minWidth: 90
    },
    [theme.breakpoints.up('sm')]: {
      width: 150,
      height: 120,
      minWidth: 150
    }
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      height: 60
    },
    [theme.breakpoints.up('sm')]: {
      height: 100
    }
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    cursor: 'pointer',
  }
}));

/**
 * Image selector item.
 * @param {image, showDate, handleSelect, orientation} props
 */
function Item(props) {
  const { image, showDate, handleSelect, orientation } = props;
  const classes = useStyles();

  const date = parseISO(image.capturedAt);
  const dateShort = format(date, 'd/MM/yyyy');
  const dateLong = format(date, 'd/MM/yyyy h:mm a');

  return (
    <div
      className={classes.root}
      onClick={handleSelect}
      style={{
        [orientation === 'h' ? 'marginRight' : 'marginBottom']: 14
      }}
    >
      {showDate && <span>{dateShort}</span>}

      <NPaper className={classes.paper}>
        <img
          src={image.urls.small}
          alt={`Captured at ${dateLong}`}
          title={`Captured at ${dateLong}`}
          className={classes.image}
        />
      </NPaper>
    </div>
  );
}

export default Item;
